import { LogLevel, PublicClientApplication } from '@azure/msal-browser'

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: '85968b2b-c217-48ec-8710-b465c6ca802a',
    redirectUri: window.location.origin + '/callback', // Must be registered as a SPA redirectURI on your app registration
    authority: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
    postLogoutRedirectUri: window.location.origin + '/callback' // Must be registered as a SPA redirectURI on your app registration
  },
  cache: {
    cacheLocation: 'localStorage'
  },
  system: {
      loggerOptions: {
          loggerCallback: (level, message, containsPii) => {
              if (containsPii) {	
                  return	
              }
              switch (level) {	
                  case LogLevel.Error:	
                      console.error(message)	
                      return	
                  case LogLevel.Info:	
                      console.info(message)	
                      return	
                  case LogLevel.Verbose:	
                      console.debug(message)	
                      return	
                  case LogLevel.Warning:	
                      console.warn(message)	
                      return	
                  default:
                      return
              }
          },
          logLevel: LogLevel.Verbose
      }
  }
}

export const msalInstance = new PublicClientApplication(msalConfig)
// Add here scopes for id token to be used at MS Identity Platform endpoints.

export const loginRequest = {
  //scopes: ['User.Read'],
  scopes: ['api://85968b2b-c217-48ec-8710-b465c6ca802a/SESSION:ROLE-ANY'],
  forceRefresh: true
}

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
}
